// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { MainPanelHeader } from '../../../../template';
import { getSafeCustomerName, usePendingIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';
import { getFirstName } from '@tectonics/commons/get-first-name';
import { CapitalizedSpan } from '@tectonics/components/capitalized';

export function MobileVoucherHeader(): Node {
  return (
    <MobileWrapper>
      <ContentMessage />
    </MobileWrapper>
  );
}

export function DesktopVoucherHeader(): Node {
  return (
    <DesktopWrapper>
      <ContentMessage />
    </DesktopWrapper>
  );
}

function ContentMessage(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const country = getCountry(incomingPayment);
  const firstName = getFirstName(getSafeCustomerName(incomingPayment)).toLowerCase();

  switch (country) {
    case 'br':
      return <p><CapitalizedSpan>{firstName}</CapitalizedSpan>, seu boleto foi gerado. Pague agora!</p>;

    case 'mx':
      return <p><CapitalizedSpan>{firstName}</CapitalizedSpan>, tu boleta fue generada ¡Paga ahora!</p>;

    case 'ar':
      return <p><CapitalizedSpan>{firstName}</CapitalizedSpan>, tu Cupón de pago fue generado con éxito.
      ¡Agiliza la confirmación de tu pedido pagando cuanto antes!</p>;

    case 'bo':
    case 'cl':
    case 'co':
    case 'ec':
    case 'pe':
      return <p><CapitalizedSpan>{firstName}</CapitalizedSpan>, tu recibo de pago fue generado ¡Paga ahora!</p>;

    default:
      throw new Error(`PendingPageHeader - There is no implementation for country "${country}."`);
  }
}

const MobileWrapper = styled(MainPanelHeader)`
  align-items: center;
  color: ${props => props.theme.colors.secondary(30)};
  font-family: ${props => props.theme.fontFamily.display};
  font-size: 1.3em;
  font-weight: 400;
  padding: 16px;
  text-align: center;
  @media (min-width: 840px) {
    display: none;
  }
`;

const DesktopWrapper = styled(MainPanelHeader)`
  min-height: 64px;
  display: none;
  text-align: center;
  color: ${props => props.theme.colors.secondary(30)};
  font-family: ${props => props.theme.fontFamily.display};
  font-size: 21px;
  font-weight: 300;
  padding: 1em;
  @media (min-width: 840px) {
    display: flex;
    align-items: center;
  }
`;
